import denormalizeResponse from '@/utils/denormalizeResponse'

export const getResource = (state) => (root) => {
    const response = {
        root,
        resources: state.resources,
    };
    return denormalizeResponse(response).root;
}